import React from 'react'

export default ({ title }) => {
  return <h2 className='title-page'>{title}</h2>
}
